import { useQuery, useQueryClient } from '@tanstack/react-query';

import { billingKeys, fetchBillingOverview } from './billing-api';

export function useBillingOverview() {
  const { data, isLoading, error } = useQuery({
    queryFn: fetchBillingOverview,
    queryKey: billingKeys.overview(),
    refetchOnMount: 'always',
    staleTime: 0,
  });

  return {
    overview: data,
    isLoading,
    error: error instanceof Error ? error.message : null,
  };
}

export function useInvalidateBillingOverview() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: billingKeys.overview() });
  };
}
